import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { useAuth } from "./lib/auth";
import { LoginPage } from "./pages/Login";
import { DashboardPage } from "./pages/Dashboard";
import { CustomersPage } from "./pages/Customers";
import { CustomerDetailPage } from "./pages/CustomerDetail";
import { WorkBoardPage } from "./pages/WorkBoard";
import { JobWorkspacePage } from "./pages/JobWorkspace";
import { PosPage } from "./pages/Pos";
import { FinancePage } from "./pages/Finance";
import { ReportsPage } from "./pages/Reports";
import { SettingsPage } from "./pages/Settings";
import { ApprovalPage } from "./pages/Approval";
import { AppointmentsPage } from "./pages/Appointments";
import { ReceiptPage } from "./pages/Receipt";
import { VehicleDetailPage } from "./pages/VehicleDetail";
import { TimeClockPage } from "./pages/TimeClock";
import { PartsCatalogPage } from "./pages/PartsCatalog";

function RequireAuth({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center" aria-busy="true">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-teal-600" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function App() {
  return (
    <Routes>
      {/* Public: the customer approval link carries its own scoped token. */}
      <Route path="/approve/:token" element={<ApprovalPage />} />
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="customers/:id" element={<CustomerDetailPage />} />
        <Route path="vehicles/:id" element={<VehicleDetailPage />} />
        <Route path="appointments" element={<AppointmentsPage />} />
        <Route path="board" element={<WorkBoardPage />} />
        <Route path="jobs/:id" element={<JobWorkspacePage />} />
        <Route path="pos" element={<PosPage />} />
        <Route path="pos/:invoiceId" element={<PosPage />} />
        <Route path="receipts/:invoiceId" element={<ReceiptPage />} />
        <Route path="timeclock" element={<TimeClockPage />} />
        <Route path="parts-catalog" element={<PartsCatalogPage />} />
        <Route path="finance" element={<FinancePage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      <Route
        path="*"
        element={
          <div className="flex min-h-screen flex-col items-center justify-center gap-2 p-8 text-center">
            <h1 className="text-lg font-semibold text-ink">That page does not exist</h1>
            <a href="/" className="text-sm text-teal-700 underline">
              Back to the dashboard
            </a>
          </div>
        }
      />
    </Routes>
  );
}
